/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![FlagPlusIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABMklEQVR4nO2VvUoEQQzHr7IVQfDjbURB8Db/ZIXZRO3ttDnQJxCsrCz0ZSzu8GFEvVb8gJVZWJjb2725vVWxuECamUx+kzD5T6/3V0Zij2Ad1e2l6ckWkO0htXNivYXYNZFttAJALPeesO4WiUTvPBCi43IvdBJ7WAgwrxPbV12eA+c2nXOrnQEIqoXYfVgtsb2T6GlnAGa6Pv8ywPIlIF+2KJ8eLn0h1qfK2gexXQC27SWFWC8h9jnzFRHbK4kNvVwQ25kfqFJ7iG1QiR1Uh7YAio5rAX7UG+UE2Q5Y3yYAJTgQS+fcCnO2XwtoSk6ih2XpYcvmPR8NSJKjdYhdkegNYOj3j9fanI8HROzHAeR7HtOj8ANrC0Ahz5E/Q2y4MKB9i1hHE8SWho4X/AeAhg58A40IRo3VLPpzAAAAAElFTkSuQmCC)
 */
export const FlagPlusIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        d="M19 14a1 1 0 0 1 1 1v3h3a1 1 0 0 1 0 2h-3v3a1 1 0 0 1-2 0v-3h-3a1 1 0 1 1 0-2h3v-3a1 1 0 0 1 1-1Z"
        fill={typeof color === 'string' ? color : color.css}
        className={colorClass}
      />
      <path
        d="M21.85 14.07c.12.36.54.57.76.27a2 2 0 0 0 .39-1.19v-7.3a2 2 0 0 0-2.33-1.98L15 4.82V3.35a2 2 0 0 0-2.33-1.98L4 2.82V2a1 1 0 0 0-2 0v19a1 1 0 1 0 2 0v-6.82l8.2-1.37c.37-.06.65.28.47.6a5.01 5.01 0 0 1-1.94 1.94c-.26.14-.38.47-.18.68a2 2 0 0 0 1.78.6c.37-.07.73-.18 1.09-.3.52-.16 1.04-.33 1.58-.33h.5a.5.5 0 0 0 .5-.5V15a3 3 0 0 1 5.85-.93Z"
        fill={typeof color === 'string' ? color : color.css}
        className={colorClass}
      />
    </svg>
  );
};
